var _htmlServeisWMS = [],
_NomServer2 = "",
WMS_BBOX,
ActiuWMS = {
	"servidor" : "servidor",
	"url" : "url",
	"layers" : "layers",
	"epsg" : 'L.CRS.EPSG4326',
	"tileSize":"512",
	"wmstime":false,
	"sostenibilitat":false
};

function generaLlistaServeisWMS() {
	_htmlServeisWMS.push('<div class="panel-success"><ul class="bs-dadesO panel-heading">');
	var llista_servidorsWMS = {
		"WMS" : [
			{
				"TITOL" : "Base municipal",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" : "https://geoserveis.icgc.cat/servei/catalunya/divisions-administratives/wms?",
				"URN" : "urn:uuid:761da3ce-233c-11e2-a4dd-13da4f953834"
			},
			{
				"TITOL" : "Sismologia",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" : "https://geoserveis.icgc.cat/icgc_sismicitat/wms/service?",
				"URN" : "urn:uuid:761da3ce-233c-11e2-a4dd-13da4f953834"
			},
			{
				"TITOL" : "Mapa Cadastral",
				"ORGANITZAC" : "Dirección General del Catastro",
				"IDARXIU" : "https://ovc.catastro.meh.es/Cartografia/WMS/ServidorWMS.aspx?",
				"URN" : "urn:uuid:260c0ccb-233c-11e2-a4dd-13da4f953834"
			},
			
			{ 
				"TITOL" : "Mapa geològic 1:50.000",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" :  "https://geoserveis.icgc.cat/icgc_mg50m/wms/service?", 
				"URN" :"urn:uuid:873ee728-cc2c-11e2-a37e-f96b77832722"
			},			
			{
				"TITOL" : "Ortofotos en curs i històriques",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" : "http://geoserveis.icgc.cat/servei/catalunya/orto-territorial/wms?",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			{
				"TITOL" : "Noms i numeració carrers",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" : "https://geoserveis.icgc.cat/icc_bv5m/wms/service?",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			{
				"TITOL" : "Seccions censals",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" : "https://geoserveis.icgc.cat/icc_bseccen/wms/service?",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			/*
			{
                "TITOL" : "Població Catalunya 2014-2016",
                "ORGANITZAC" : "Institut d'Estadística de Catalunya",
                "IDARXIU" : "https://www.instamaps.cat/geotimeservices/idescat",
                "URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			/*
			{
				"TITOL" : "Establiments industrials",
				"ORGANITZAC" : "Direccio General de Difusio",
				"IDARXIU" : "http://pcivil.icgc.cat/ogc/geoservei?map=/opt/idec/dades/pcivil/risc_quimic.map&amp",
				"URN" : "urn:uuid:0a71e360-7f73-11e4-b2ac-e7f91a2c3576"
			},
			
			{
				"TITOL" : "Ortofotos històriques",
				"ORGANITZAC" : "Institut Cartogràfic i Geològic de Catalunya",
				"IDARXIU" : "http://geoserveis.icgc.cat/icc_ortohistorica/wms/service?",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			{
				"TITOL" : "Risc Sísmic",
				"ORGANITZAC" : "Direccio General de Difusio",
				"IDARXIU" : "http://pcivil.icgc.cat/ogc/geoservei?map=/opt/idec/dades/pcivil/risc_sismic.map&",
				"URN" : "urn:uuid:09e7f2c8-7f73-11e4-b2ac-e7f91a2c3576"
			},
			{
				"TITOL" : "Cobertes del Sòl",
				"ORGANITZAC" : "Centre de Recerca Ecològica i Aplicacions Forestals (CREAF) - UAB",
				"IDARXIU" : "http://www.opengis.uab.es/cgi-bin/MCSC/MiraMon.cgi?",
				"URN" : "urn:uuid:54012596-233b-11e2-a4dd-13da4f953834"
			},
			
			{
				"TITOL" : "Nodes guifi.net",
				"ORGANITZAC" : "GUIFI.NET",
				"IDARXIU" : "http://guifi.net/cgi-bin/mapserv?map=/home/guifi/maps.guifi.net/guifimaps/GMap.map&",
				"URN" : "urn:uuid:63013742-233c-11e2-a4dd-13da4f953834"
			},
			*/
			{
                "TITOL" : "Costes - SIG Corporatiu",
                "ORGANITZAC" : "Generalitat de Catalunya",
                "IDARXIU" : "https://sig.gencat.cat/ows/COSTES/wms?",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			{
                "TITOL" : "Espais naturals - SIG Corporatiu",
                "ORGANITZAC" : "Generalitat de Catalunya",
                "IDARXIU" : "https://sig.gencat.cat/ows/ESPAIS_NATURALS/wms?",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			},
			{
                "TITOL" : "Mapa Urbanístic de Catalunya",
                "ORGANITZAC" : "Generalitat de Catalunya",
                "IDARXIU" : "http://dtes.gencat.cat/webmap/MUC/service.svc/get",
				"URN" : "urn:uuid:6434ad48-66df-11e2-8be5-bd1ed7ebebe1"
			}
			
		]
	};	
	
	jQuery.each(llista_servidorsWMS.WMS, function(key, WMS) {
		if(WMS.WMST){
			_htmlServeisWMS.push('<li><a class="label-wms" href="#" id="' +
				WMS.IDARXIU +
				'">' +
				window.lang.translate(WMS.TITOL) +
				'</a>' +
				'<a target="_blank" lang="ca" title="Servei WMS-TIME" href="' +
				WMS.IDARXIU +'&Request=GetCapabilities&service=WMS' +
				'"><span class="glyphicon glyphicon-time info-wms"></span></a>' +
				'</li>');
		}else{
			_htmlServeisWMS.push('<li><a class="label-wms" href="#" id="' +
				WMS.IDARXIU +
				'">' +
				window.lang.translate(WMS.TITOL) +
				'</a>' +
				//'<a target="_blank" lang="ca" title="Informació dels serveis" href="http://www.geoportal.cat/wefex/client?idioma=ca&do=cercaAssociacions&resposta=detall&id=' +
				//WMS.URN +
				'<a target="_blank" lang="ca" title="'+WMS.ORGANITZAC+'" href="' +
				WMS.IDARXIU +'?Request=GetCapabilities&service=WMS' +
				'"><span class="glyphicon glyphicon-info-sign info-wms"></span></a>' +
				'</li>');
		}
	});
	
	_htmlServeisWMS.push('<li></li>');
	_htmlServeisWMS.push('<li><hr></li>');
	_htmlServeisWMS.push('<li><div class="input-group txt_ext0">');
	_htmlServeisWMS.push('<a target="_blank" href="https://www.icgc.cat/Administracio-i-empresa/Serveis/Geoinformacio-en-linia-Geoserveis">Geoserveis ICGC  <span class="fa fa-external-link-square info-wms"></span></a>');
	
	_htmlServeisWMS.push('</div></li>');

	_htmlServeisWMS.push('<li><div class="input-group txt_ext0">');
	_htmlServeisWMS.push('<a target="_blank" href="https://territori.gencat.cat/ca/serveis/visors-cartografia/serveis-web-geografics/index.html">Geoserveis SIG Corporatiu<span class="fa fa-external-link-square info-wms"></span></a>');
	
	_htmlServeisWMS.push('</div></li>');

	_htmlServeisWMS.push('<li><div class="input-group txt_ext0">');
	
	_htmlServeisWMS.push('<a target="_blank" href="https://ide.cat/geonetwork/srv/cat/catalog.search?node=srv#/search?facet.q=type%2Fservice&resultType=details&sortBy=relevance&from=1&to=20&fast=ind">Catàleg IDEC <span class="fa fa-external-link-square info-wms"></span></a>');
	_htmlServeisWMS.push('</div></li>');

//	_htmlServeisWMS.push('<li><div class="input-group txt_ext"><input type="text" lang="ca" id="txt_URLWMS_cataleg" style="height:33px" placeholder="Cercar catàleg IDEC" class="form-control">');
//	_htmlServeisWMS.push('<span class="input-group-btn"><button class="btn btn-success" id="bt_cercaWMS"  type="button"><span class="glyphicon glyphicon-search"></span></button></span>');
//	_htmlServeisWMS.push('</div></li>');
	_htmlServeisWMS.push('</ul></div>');
	_htmlServeisWMS.push('<div id="resultats_idec">');
	_htmlServeisWMS.push('</div>');
	_htmlServeisWMS.push('<div id="div_controlWMS"></div>');
	_htmlServeisWMS.push('<div id="div_emptyWMS"></div>');
}

jQuery(document).on('keyup', "#txt_URLWMS_cataleg", function(e) {
    var code = e.which; // recommended to use e.which, it's normalized across browsers
    if(code==13) {//enter
    	e.preventDefault();
    	e.stopImmediatePropagation();
    	var cerca = $.trim(jQuery('#txt_URLWMS_cataleg').val());
    	if (cerca === "") {
    		alert(window.lang.translate("Has d'introduïr un valor per fer la cerca"));
    	} else {
    		cercaCataleg(cerca);
    	}
    }
});

jQuery(document).on('click', "#bt_cercaWMS", function(e) {
	var cerca = $.trim(jQuery('#txt_URLWMS_cataleg').val());
	if (cerca === "") {
		alert(window.lang.translate("Has d'introduïr un valor per fer la cerca"));
	} else {
		cercaCataleg(cerca);
	}
});

jQuery(document).on('change', "#cmd_geoserveis_list", function(e) {
	if($(this).val()=="TMS" || $(this).val()=="WMTS" ){
		jQuery('#txt_URLWMS').attr('placeholder','Esquema: http://domain.com/{z}/{x}/{y}.png');	
	}else{
		jQuery('#txt_URLWMS').attr('placeholder','Esquema: http://domain.com/geoservice?');	
	}
});

function cercaCataleg(cerca){
	cerca = encodeURI(cerca);
	var data ={
		searchInput : cerca	
	};
	//Cerca catàleg IDEC
	searchCatalegIdec(data).then(function(results){
		var resultats = JSON.parse(results.resultats);
		jQuery('#div_layersWMS').attr("style","display:none;");
		var lDadesIdec = '<ul class="panel-heading llista-dadesIdec">';
		jQuery.each(resultats.aaData, function( index, wmsidec ) {
			var titol=wmsidec.TITOL;
			var titolShort=InstamapsUtils.Getters.shortString(titol,27);
			var desc=wmsidec.DESCRIPCIO;
			var org =wmsidec.ORGANITZAC;
			var idarxiu=wmsidec.IDARXIU;
			var classificaico=wmsidec.CLASSIFICA;
			var urn=wmsidec.URN;
			var xmin=wmsidec.XMIN;
			var xmax=wmsidec.XMAX;
			var ymin=wmsidec.YMIN;
			var ymax=wmsidec.YMAX;
			var escala=wmsidec.ESCALA;
			var conjunt=wmsidec.CONJUNT;
			var temes=wmsidec.TEMES;
			lDadesIdec += '<li><a class="label-dadesIdec" href="#" title="'+titol+'"  data-nom="'+titol+'" data-wms_url="'+idarxiu+'">'+titolShort;
			lDadesIdec += '<a lang="ca" href="http://www.geoportal.cat/wefex/client?idioma=ca&do=cercaAssociacions&resposta=detall&id='+urn+'&idioma=ca&" target="_blank">';
			lDadesIdec += '&nbsp;<span class="glyphicon glyphicon-info-sign"></span></a></li>';
		});
		lDadesIdec += '</ul>';
		if (resultats.aaData.length>0) {
			jQuery('#resultats_idec').html(lDadesIdec);
			//TODO llamar al control
			jQuery('#txt_URLWMS').attr("style","display:none");
			jQuery('#bt_connWMS').attr("style","display:none");
			jQuery(".label-dadesIdec").on('click', function(e) {
				jQuery('#resultats_idec').empty();
				var urlWMS= this.dataset.wms_url;
				//$.publish('analyticsEvent',{event:['mapa', tipus_user+'afegir WMS catàleg IDEC', this.dataset.nom, 1]});
				jQuery('#txt_URLWMS').attr("style","display:block;height:33px;");
				jQuery('#bt_connWMS').attr("style","display:inline");
				jQuery('#txt_URLWMS').val(urlWMS);
				jQuery('#bt_connWMS').click();
			});
		}
	});
}

function getCapabilitiesWMS(url, servidor) {
	var _htmlLayersWMS = [];
	var instamapsWms = InstamapsWms({
		loadTemplateParam :false});
	var dataWMS = {url: url};
	instamapsWms.getWMSLayers(dataWMS).then(function(results) {
		var bbox,
		souce_capabilities_template = $("#capabilities-template").html(),
		capabilities_template = Handlebars.compile(souce_capabilities_template);
		
		Handlebars.registerPartial( "list-template", $( "#list-template" ).html() );
		Handlebars.registerHelper('layer', function(context, options) {
		  var ret = "";
		  if (!Handlebars.Utils.isArray(context)){
			  context = [context];
		  }
		  for(var i=0, j=context.length; i<j; i++) {
			  if (!Handlebars.Utils.isArray(context[i])){
				  ret = ret + options.fn(context[i]);
			  }else{
				  for(var k=0, l=context.length; k<l; k++) {
					  ret = ret + options.fn(context[i][k]);
				  }
			  }
		  }
		  return ret;
		});
		
		jQuery('#div_layersWMS').html('');
		jQuery("#div_layersWMS").show();
		jQuery('#div_emptyWMS').empty();

		if (servidor === null) {
			servidor = results.Service.Title;
		}
		try{
			if(results.Capability.Layer.Layer.LatLonBoundingBox){
				bbox = results.Capability.Layer.Layer.LatLonBoundingBox;
				WMS_BBOX=[[bbox["@miny"], bbox["@minx"]],[bbox["@maxy"], bbox["@maxx"]]];
			}else if(results.Capability.Layer.LatLonBoundingBox){
				bbox = results.Capability.Layer.LatLonBoundingBox;
				WMS_BBOX=[[bbox["@miny"], bbox["@minx"]],[bbox["@maxy"], bbox["@maxx"]]];
			}else{
				WMS_BBOX=null;
			}	
		} catch (err) {
			WMS_BBOX=null;
		}
		
		try {
			var matriuEPSG = results.Capability.Layer.CRS,
			epsg = [],
			html = capabilities_template({Layer: [results.Capability.Layer]});
			
			ActiuWMS.servidor = servidor;
			_NomServer2=ActiuWMS.servidor;
			ActiuWMS.url = jQuery.trim(url);
			
			
			if (!matriuEPSG) {
				matriuEPSG = results.Capability.Layer.SRS;
				if (!matriuEPSG) {
					matriuEPSG = results.Capability.Layer[0].CRS;
					
					if (!matriuEPSG) {
						matriuEPSG = results.Capability.Layer[0].SRS;
					}
				}
			}
			if (jQuery.isArray(matriuEPSG)){
				jQuery.each(matriuEPSG, function(index, value) {
					epsg.push(value);
				});
			}else{
				epsg.push(matriuEPSG);
			}
	
			if (jQuery.inArray('EPSG:3857', epsg) != -1) {
				ActiuWMS.epsg = L.CRS.EPSG3857;
				ActiuWMS.epsgtxt = 'EPSG:3857';
			} else if (jQuery.inArray('EPSG:900913', epsg) != -1) {
				ActiuWMS.epsg = L.CRS.EPSG3857;
				ActiuWMS.epsgtxt = 'EPSG:3857';
			} else if (jQuery.inArray('EPSG:4326', epsg) != -1) {
				ActiuWMS.epsg = L.CRS.EPSG4326;
				ActiuWMS.epsgtxt = 'EPSG:4326';
			} else if (jQuery.inArray('CRS:84', epsg) != -1) {
				ActiuWMS.epsg = L.CRS.EPSG4326;
				ActiuWMS.epsgtxt = '4326';
			} else if (jQuery.inArray('EPSG:4258', epsg) != -1) {
				ActiuWMS.epsg = L.CRS.EPSG4326;
				ActiuWMS.epsgtxt = 'EPSG:4326';	
			} else {
				alert(window.lang.translate("No s'ha trobat un EPSG vàĺid al capabilities. Intento connectar amb EPSG:3857"));
				ActiuWMS.epsg = L.CRS.EPSG3857;
				ActiuWMS.epsgtxt = 'EPSG:3857';
				
				//return;
			}
			
			jQuery('#div_layersWMS').empty().append(html);
			addTreeEvents();
			jQuery('#div_emptyWMS').empty();
			jQuery('#div_emptyWMS').html(
				'<div style="float:right"><button lang="ca" id="bt_addWMS" class="btn btn-success" >' +
				window.lang.translate("Afegir capes") + '</button></div>');
		} catch (err) {
			jQuery('#div_layersWMS').html('<hr>Error interpretar capabilities: ' + err + '</hr>');
		}
	},function(){ console.info("time out")});
}

function addWmsToMap(wms){
	var wmsLayer,
	tipus_user = defineTipusUser();  //geocat.web-1.0.0	
	var dfd = $.Deferred();
	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'wms', wms.url, 1]});
	var tileSize=512;
	if (wms.url.indexOf("catastro")>-1) tileSize=1024;
	if(!wms.sostenibilitat){
		wms.sostenibilitat=false;
	}	
	
	if(wms.wmstime){
		wmsLayer = L.tileLayer.wms(wms.url, {
			layers : wms.layers,
			crs : wms.epsg,
			transparent : true,
			format : 'image/png',
			wmstime:wms.wmstime,
			sostenibilitat:wms.sostenibilitat,
			tileSize:512
		});
	}else{
		wmsLayer = L.tileLayer.betterWms(wms.url, {
			layers : wms.layers,
			crs : wms.epsg,
			transparent : true,
			exceptions:checkExceptionsType(wms.url),
			format : 'image/png',
			wmstime:wms.wmstime,
			sostenibilitat:wms.sostenibilitat,
			tileSize:tileSize
		});
	}	

	wmsLayer.options.businessId = '-1';
	//wmsLayer.options.nom = (wms.servidor).replaceAll(" ","_").replaceAll("%20","_");
	wmsLayer.options.tipus = t_wms;
	wmsLayer.options.sostenibilitat = wms.sostenibilitat;

	try{
		if(wms.epsg.code){ActiuWMS.epsg=wms.epsg.code}
	}catch(err){
		ActiuWMS.epsg=ActiuWMS.epsg;
	}

	if(typeof url('?businessid') == "string"){
		var order = 0;
		if(controlCapes){
			order = controlCapes._lastZIndex+1;
		}
		var nameS = wms.servidor;
		if(nameS == null || nameS=="null"){

			nameS = "Servei wms";
		}
		var data = {
			uid:Cookies.get('uid'),
			mapBusinessId: url('?businessid'),
			serverName: nameS,
			serverType: t_wms,
			version: wmsLayer.wmsParams.version,
			calentas: false,
            activas: true,
            visibilitats: true,
            order: order,
            epsg: ActiuWMS.epsg,
            imgFormat: 'image/png',
            infFormat: 'text/html',
            tiles: true,	            
            transparency: true,
            opacity: 1,
            visibilitat: 'O',
            url: wms.url,
            layers: JSON.stringify([{name:wms.layers,title:wms.layers,group:0,check:true,query:true,epsg:ActiuWMS.epsg}]),
            calentas: false,
            activas: true,
            visibilitats: true,
			options: '{"url":"'+wms.url+'","layers":"'+wms.layers+'","opacity":"'+1+'","wmstime":'+wms.wmstime+',"sostenibilitat":'+wms.sostenibilitat+',"epsg":"'+ActiuWMS.epsg+'"}'
		};

		createServidorInMap(data).then(function(results){
			map.spin(false);
			if (results.status == "OK"){
				wmsLayer.options.businessId = results.results.businessId;
				checkAndAddTimeDimensionLayer(wmsLayer,false,wms.servidor);
				controlCapes.forceUpdate(true);
				dfd.resolve(true);
			}else{ 
				console.debug('createServidorInMap ERROR');
				dfd.resolve(false);
			}
		});
	}else{
		dfd.resolve(false);
		checkAndAddTimeDimensionLayer(wmsLayer,false,wms.servidor);
		controlCapes.forceUpdate(true);
	}
	//return wmsLayer;
	return dfd.promise();
}

/*
 * fromParam = true -> Si afegim WMS directamente dun parametre de la url
 * fromParam = false -> Si afegim WMS des de la interficie dInstaMaps
 * */
function addExternalWMS(fromParam) {
	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'wms', ActiuWMS.url, 1]});
	
	var dfd = $.Deferred();
	var _dateFormat=false,
	nomCapaWMS,
	wmsLayer;
	
	if(!fromParam){
		var cc = $('#div_layersWMS input:checked').map(function(){
			if($('#geoservicetime_'+this.value).length > 0){
				_dateFormat=true;
			}
			return this.value;
		});
		cc = jQuery.makeArray(cc);
		ActiuWMS.layers = cc.join(',');
		
		var _nomCapesWMS=[];
		var cc1 = $('#div_layersWMS input:checked').map(function(){			
			return this.id;
		});
		
		cc1 = jQuery.makeArray(cc1);	
		
		if(cc1.length==1){
			ActiuWMS.servidor=cc1.join(" ");
		}else{
			ActiuWMS.servidor=_NomServer2;		
		}
		ActiuWMS.wmstime=_dateFormat;
		if(!ActiuWMS.sostenibilitat){
			ActiuWMS.sostenibilitat=false;
		}	
	}
	var tileSize=512;
	if (ActiuWMS.url.indexOf("catastro")>-1) tileSize=1024;
	if(ActiuWMS.wmstime){
		wmsLayer =L.tileLayer.wms(ActiuWMS.url, {
			layers : ActiuWMS.layers,
			crs : ActiuWMS.epsg,
			transparent : true,
			format : 'image/png',
			wmstime:ActiuWMS.wmstime,
			sostenibilitat:ActiuWMS.sostenibilitat,		
			tileSize:512
		});
	}else{
		wmsLayer = L.tileLayer.betterWms(ActiuWMS.url, {
			layers : ActiuWMS.layers,
			crs : ActiuWMS.epsg,
			transparent : true,
			//exceptions:'application/vnd.ogc.se_blank',
			exceptions:checkExceptionsType(ActiuWMS.url),
			format : 'image/png',
			wmstime:ActiuWMS.wmstime,
			sostenibilitat:ActiuWMS.sostenibilitat,	
			tileSize:tileSize
		});
	}
	
	nomCapaWMS=ActiuWMS.servidor;	
	wmsLayer.options.businessId = '-1';
	wmsLayer.options.nom = nomCapaWMS;
	wmsLayer.options.tipus = t_wms;
	wmsLayer.options.tipus = t_wms;
	wmsLayer.options.sostenibilitat = ActiuWMS.sostenibilitat;
	
	if(typeof url('?businessid') == "string"){
		var order = 0;
		if(controlCapes){
			order = controlCapes._lastZIndex+1;
		}


		var nameS = ActiuWMS.servidor;
		if(nameS == null || nameS=="null"){

			nameS = "Servei wms";
		}


		var data = {
			uid:Cookies.get('uid'),
			mapBusinessId: url('?businessid'),
			serverName: nameS,
			serverType: t_wms,
			version: wmsLayer.wmsParams.version,
			calentas: false,
            activas: true,
            visibilitats: true,
            order: order,
            epsg: ActiuWMS.epsgtxt,
            imgFormat: 'image/png',
            infFormat: 'text/html',
            tiles: true,	            
            transparency: true,
            opacity: 1,
            visibilitat: 'O',
            url: ActiuWMS.url,
            layers: JSON.stringify([{name:ActiuWMS.layers,title:ActiuWMS.layers,group:0,check:true,query:true}]),
            calentas: false,
            activas: true,
            visibilitats: true,
			options: '{"url":"'+ActiuWMS.url+'","layers":"'+ActiuWMS.layers+'","opacity":"'+1+'","wmstime":'+ActiuWMS.wmstime+',"sostenibilitat":'+ActiuWMS.sostenibilitat+'}'
		};
		
		createServidorInMap(data).then(function(results){
			map.spin(false);
			if (results.status == "OK"){
				wmsLayer.options.businessId = results.results.businessId;
				checkAndAddTimeDimensionLayer(wmsLayer,false,ActiuWMS.servidor);
				//Issue #581: zoom capa cloudifier
				if (results.results!=undefined && results.results.url!=undefined && results.results.url.indexOf("betaserver.icgc.cat/geoservice/")!=-1){
					var instamapsWms = InstamapsWms({
						loadTemplateParam :false});
					var dataWMS = {url: results.results.url};
					instamapsWms.getWMSLayers(dataWMS).then(function(results2) {
						try{
							if(results2.Capability.Layer.Layer.LatLonBoundingBox){
								var bbox = results2.Capability.Layer.Layer.LatLonBoundingBox;
								WMS_BBOX=[[bbox["@miny"], bbox["@minx"]],[bbox["@maxy"], bbox["@maxx"]]];
							}else if(results2.Capability.Layer.LatLonBoundingBox){
								
								var bbox = results2.Capability.Layer.LatLonBoundingBox;
								WMS_BBOX=[[bbox["@miny"], bbox["@minx"]],[bbox["@maxy"], bbox["@maxx"]]];
							}else{
								WMS_BBOX=null;
							}	
						} catch (err) {
							WMS_BBOX=null;
						}
						if (WMS_BBOX !=null) map.fitBounds(WMS_BBOX);
					});
				}
				dfd.resolve(true);
			}else{
				console.debug('createServidorInMap ERROR');
				dfd.resolve(false);
			}
		});
	}else{
		dfd.reject();
		checkAndAddTimeDimensionLayer(wmsLayer,false,ActiuWMS.servidor);
	}
	
	 return dfd.promise();
}

function showTimeControl(show){
	show ? $('.barra_temps').show() : $('.barra_temps').hide();
}

function checkAndAddTimeDimensionLayer(wmsLayer,ckeckCapaActiva,_nomServidor,capesActiva,_map){
	var defer = $.Deferred();
	var DL= wmsLayer.options.wmstime;
	_map = _map || map;
	if(wmsLayer.options.wmstime) {
		var dimensionsTimeLayer = new L.IM_TimeDimension.Layer.WMS(wmsLayer, {
		    proxy: paramUrl.proxy_betterWMS,
		    updateTimeDimension: true,
		    updateTimeDimensionMode:'intersect',//replace, union,intersect
		    tileSize:512,
		    setDefaultTime:false,
		    tipus : t_wms
		});
		dimensionsTimeLayer.options=wmsLayer.options;
		dimensionsTimeLayer.addTo(_map);
		dimensionsTimeLayer.bringToFront();
		
		if(controlCapes){
			dimensionsTimeLayer.options.zIndex = controlCapes._lastZIndex+ 1;
			controlCapes.addOverlay(dimensionsTimeLayer, _nomServidor, true);
			controlCapes._lastZIndex++;
			InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
			if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
				updateSortablesElements();
			}
		}
		jQuery('#dialog_dades_ex').modal('hide');	
		
		showTimeControl(true);
		defer.resolve(dimensionsTimeLayer);
	}else{
		if(ckeckCapaActiva){
			if (true === capesActiva || 'true' === capesActiva){
				wmsLayer.addTo(_map);
			}
			if(controlCapes){
				controlCapes.addOverlay(wmsLayer, _nomServidor, true);
				controlCapes._lastZIndex++;	
			}
		}else{
			_map.addLayer(wmsLayer);
			wmsLayer.bringToFront();
			if(controlCapes){
				wmsLayer.options.zIndex = controlCapes._lastZIndex+ 1;
				controlCapes.addOverlay(wmsLayer, _nomServidor, true);
				controlCapes._lastZIndex++;
				InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
				if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
					updateSortablesElements();
				}
			}
			jQuery('#dialog_dades_ex').modal('hide');	
		}
		defer.resolve(wmsLayer);
	}
	return defer.promise();
}

function loadWmsLayer(layer, _map){
	var defer = $.Deferred();
	var objLayer = {activa: false, layer: null};
	var op = layer.opacity,
	jsonOptions,
	newWMS,
	nomServidor = layer.serverName;
	
	if(layer.serverName.indexOf('##') !=-1){
		var valors = layer.serverName.split("##");
		if (layer.opacity === null || layer.opacity === undefined){
			op = valors[1];
		}
		nomServidor=valors[0];
		//TODO si es editor modificar el nombre del servidor para quitar las ## y la opacidad
	}  

	jsonOptions = InstamapsUtils.Dom.cleanOptions(layer.options);
	
	if(!layer.options){
		jsonOptions=layer;
	}
	var tileSize=512;
	if (layer.url.indexOf("catastro")>-1) tileSize=1024;
	var wmsOptions = {
	    layers: layer.layers,
	    format: layer.imgFormat,
	    transparent: layer.transparency,
	    version: layer.version,
	    opacity:op ,
	    crs: layer.epsg,
		nom :nomServidor ,
		tipus: layer.serverType,
		zIndex :  parseInt(layer.capesOrdre),
	    businessId: layer.businessId,
	    tileSize:tileSize
	};
	if(layer.random){
		wmsOptions.random=layer.random;
	}

	if(layer.hasOwnProperty("capesOrdre"))
		wmsOptions.zIndex = layer.capesOrdre;

	newWMS = L.tileLayer.betterWms(layer.url, wmsOptions);
	newWMS.options.wmstime=jsonOptions.wmstime;
	newWMS.options.group=jsonOptions.group;
	
	objLayer.businessId = layer.businessId;
	if (true === layer.capesActiva || 'true' === layer.capesActiva ){
		objLayer.activa = true;
	}

	checkAndAddTimeDimensionLayer(newWMS,true,nomServidor,layer.capesActiva, _map).then(function(result){
		objLayer.layer = result;
		defer.resolve(objLayer);
	},function(){
		defer.reject();
	});
	return defer.promise();
}

function checkExceptionsType(_server){
	var exceptions='application/vnd.ogc.se_blank';
	if(_server.indexOf('instamaps.cat')==-1 ||
		 _server.indexOf('betaserver.icgc')==-1 ||
		 _server.indexOf('localhost')==-1 ||
		 _server.indexOf('172.20.70.11')==-1){
		exceptions='application/vnd.ogc.se_inimage';

	}
	return exceptions;
}